import i18n from '@/i18n/i18n'

const { t } = i18n.global

export const FARMER_DOCUMENT_TYPE = {
  KYC: 1,
  IDENTITY_CARD: 2,
  NEW_ID_CARD: 3,
  OLD_ID_CARD: 4,
  RESIDENCE_CERTIFICATE: 5,
  FARMER_REGISTRY_CERTIFICATE: 6,
  ANIMAL_REGISTRY_CERTIFICATE: 7,
  LARGE_RUMINANTS:8,
  SMALL_RUMINANTS:9,
  EXECUTION_PROCEEDINGS:10,
  RISK_CENTER_REPORT:11,
  TRACTOR_REGISTRATION:12,
  LAND_REGISTRY:13,
  COOPERATIVE_MEMBERSHIP:14,
  CHAMBER_OF_AGRICULTURE_MEMBERSHIP:15,
  PRODUCER_RECEIPT:16,
  OTHER:17
}

export const DOCUMENT_TYPE_GROUPS = {
  ID_CARDS: [FARMER_DOCUMENT_TYPE.NEW_ID_CARD, FARMER_DOCUMENT_TYPE.OLD_ID_CARD],
  REGISTRY_CERTIFICATES: [FARMER_DOCUMENT_TYPE.FARMER_REGISTRY_CERTIFICATE, FARMER_DOCUMENT_TYPE.ANIMAL_REGISTRY_CERTIFICATE],
  INDIVIDUAL_DOCUMENTS: [
    FARMER_DOCUMENT_TYPE.RESIDENCE_CERTIFICATE,
    FARMER_DOCUMENT_TYPE.LARGE_RUMINANTS,
    FARMER_DOCUMENT_TYPE.SMALL_RUMINANTS
  ],
  APPLICATION_DOCUMENTS: [
    FARMER_DOCUMENT_TYPE.EXECUTION_PROCEEDINGS,
    FARMER_DOCUMENT_TYPE.RISK_CENTER_REPORT
  ]
}

export const FARMER_DOCUMENT_TYPE_MAP = {
  [FARMER_DOCUMENT_TYPE.KYC]: t('constants.farmer_document_type.kyc'),
  [FARMER_DOCUMENT_TYPE.IDENTITY_CARD]: t('constants.farmer_document_type.identity_card'),
  [FARMER_DOCUMENT_TYPE.NEW_ID_CARD]: t('constants.farmer_document_type.new_id_card'),
  [FARMER_DOCUMENT_TYPE.OLD_ID_CARD]: t('constants.farmer_document_type.old_id_card'),
  [FARMER_DOCUMENT_TYPE.RESIDENCE_CERTIFICATE]: t('constants.farmer_document_type.residence_certificate'),
  [FARMER_DOCUMENT_TYPE.FARMER_REGISTRY_CERTIFICATE]: t('constants.farmer_document_type.farmer_registry_certificate'),
  [FARMER_DOCUMENT_TYPE.ANIMAL_REGISTRY_CERTIFICATE]: t('constants.farmer_document_type.animal_registry_certificate'),
  [FARMER_DOCUMENT_TYPE.LARGE_RUMINANTS]: t('constants.farmer_document_type.large_ruminants'),
  [FARMER_DOCUMENT_TYPE.SMALL_RUMINANTS]: t('constants.farmer_document_type.small_ruminants'),
  [FARMER_DOCUMENT_TYPE.RISK_CENTER_REPORT]: t('constants.farmer_document_type.risk_center_report'),
  [FARMER_DOCUMENT_TYPE.EXECUTION_PROCEEDINGS]: t('constants.farmer_document_type.execution_proceedings'),
  [FARMER_DOCUMENT_TYPE.TRACTOR_REGISTRATION]: t('constants.farmer_document_type.tractor_registration'),
  [FARMER_DOCUMENT_TYPE.LAND_REGISTRY]: t('constants.farmer_document_type.land_registry'),
  [FARMER_DOCUMENT_TYPE.COOPERATIVE_MEMBERSHIP]: t('constants.farmer_document_type.cooperative_membership'),
  [FARMER_DOCUMENT_TYPE.CHAMBER_OF_AGRICULTURE_MEMBERSHIP]: t('constants.farmer_document_type.chamber_of_agriculture_membership'),
  [FARMER_DOCUMENT_TYPE.PRODUCER_RECEIPT]: t('constants.farmer_document_type.producer_receipt'),
  [FARMER_DOCUMENT_TYPE.OTHER]: t('constants.farmer_document_type.other')
}

export const FARMER_DOCUMENT_TYPE_DISPLAY_MAP = {
  [FARMER_DOCUMENT_TYPE.KYC]: t('constants.farmer_document_type.display.kyc'),
  [FARMER_DOCUMENT_TYPE.IDENTITY_CARD]: t('constants.farmer_document_type.display.identity_card'),
  [FARMER_DOCUMENT_TYPE.NEW_ID_CARD]: t('constants.farmer_document_type.display.new_id_card'),
  [FARMER_DOCUMENT_TYPE.OLD_ID_CARD]: t('constants.farmer_document_type.display.old_id_card'),
  [FARMER_DOCUMENT_TYPE.RESIDENCE_CERTIFICATE]: t('constants.farmer_document_type.display.residence_certificate'),
  [FARMER_DOCUMENT_TYPE.FARMER_REGISTRY_CERTIFICATE]: t('constants.farmer_document_type.display.farmer_registry_certificate'),
  [FARMER_DOCUMENT_TYPE.ANIMAL_REGISTRY_CERTIFICATE]: t('constants.farmer_document_type.display.animal_registry_certificate'),
  [FARMER_DOCUMENT_TYPE.LARGE_RUMINANTS]: t('constants.farmer_document_type.display.large_ruminants'),
  [FARMER_DOCUMENT_TYPE.SMALL_RUMINANTS]: t('constants.farmer_document_type.display.small_ruminants'),
  [FARMER_DOCUMENT_TYPE.RISK_CENTER_REPORT]: t('constants.farmer_document_type.display.risk_center_report'),
  [FARMER_DOCUMENT_TYPE.EXECUTION_PROCEEDINGS]: t('constants.farmer_document_type.display.execution_proceedings'),
  [FARMER_DOCUMENT_TYPE.TRACTOR_REGISTRATION]: t('constants.farmer_document_type.display.tractor_registration'),
  [FARMER_DOCUMENT_TYPE.LAND_REGISTRY]: t('constants.farmer_document_type.display.land_registry'),
  [FARMER_DOCUMENT_TYPE.COOPERATIVE_MEMBERSHIP]: t('constants.farmer_document_type.display.cooperative_membership'),
  [FARMER_DOCUMENT_TYPE.CHAMBER_OF_AGRICULTURE_MEMBERSHIP]: t('constants.farmer_document_type.display.chamber_of_agriculture_membership'),
  [FARMER_DOCUMENT_TYPE.PRODUCER_RECEIPT]: t('constants.farmer_document_type.display.producer_receipt'),
  [FARMER_DOCUMENT_TYPE.OTHER]: t('constants.farmer_document_type.display.other')
}

export const FARMER_DOCUMENT_TYPE_DATA = [
  { id: FARMER_DOCUMENT_TYPE.KYC, name: t('constants.farmer_document_type.kyc') },
  { id: FARMER_DOCUMENT_TYPE.IDENTITY_CARD, name: t('constants.farmer_document_type.identity_card') },
  { id: FARMER_DOCUMENT_TYPE.NEW_ID_CARD, name: t('constants.farmer_document_type.new_id_card') },
  { id: FARMER_DOCUMENT_TYPE.OLD_ID_CARD, name: t('constants.farmer_document_type.old_id_card') },
  { id: FARMER_DOCUMENT_TYPE.RESIDENCE_CERTIFICATE, name: t('constants.farmer_document_type.residence_certificate') },
  { id: FARMER_DOCUMENT_TYPE.FARMER_REGISTRY_CERTIFICATE, name: t('constants.farmer_document_type.farmer_registry_certificate') },
  { id: FARMER_DOCUMENT_TYPE.ANIMAL_REGISTRY_CERTIFICATE, name: t('constants.farmer_document_type.animal_registry_certificate') },
  { id: FARMER_DOCUMENT_TYPE.LARGE_RUMINANTS, name: t('constants.farmer_document_type.large_ruminants') },
  { id: FARMER_DOCUMENT_TYPE.SMALL_RUMINANTS, name: t('constants.farmer_document_type.small_ruminants') },
  { id: FARMER_DOCUMENT_TYPE.RISK_CENTER_REPORT, name: t('constants.farmer_document_type.risk_center_report') },
  { id: FARMER_DOCUMENT_TYPE.EXECUTION_PROCEEDINGS, name: t('constants.farmer_document_type.execution_proceedings') },
  { id: FARMER_DOCUMENT_TYPE.TRACTOR_REGISTRATION, name: t('constants.farmer_document_type.tractor_registration') },
  { id: FARMER_DOCUMENT_TYPE.LAND_REGISTRY, name: t('constants.farmer_document_type.land_registry') },
  { id: FARMER_DOCUMENT_TYPE.COOPERATIVE_MEMBERSHIP, name: t('constants.farmer_document_type.cooperative_membership') },
  { id: FARMER_DOCUMENT_TYPE.CHAMBER_OF_AGRICULTURE_MEMBERSHIP, name: t('constants.farmer_document_type.chamber_of_agriculture_membership') },
  { id: FARMER_DOCUMENT_TYPE.PRODUCER_RECEIPT, name: t('constants.farmer_document_type.producer_receipt') },
  { id: FARMER_DOCUMENT_TYPE.OTHER, name: t('constants.farmer_document_type.other') }
]


export const FARMER_DOCUMENT_TYPE_OPTIONS = [
  { id: FARMER_DOCUMENT_TYPE.NEW_ID_CARD, text: t('constants.farmer_document_type.official_identity') },
  { id: FARMER_DOCUMENT_TYPE.RESIDENCE_CERTIFICATE, text: t('constants.farmer_document_type.residence_certificate') },
  { id: FARMER_DOCUMENT_TYPE.FARMER_REGISTRY_CERTIFICATE, text: t('constants.farmer_document_type.farmer_registry_certificate') },
  { id: FARMER_DOCUMENT_TYPE.ANIMAL_REGISTRY_CERTIFICATE, text: t('constants.farmer_document_type.animal_registry_certificate') },
  { id: FARMER_DOCUMENT_TYPE.LARGE_RUMINANTS, text: t('constants.farmer_document_type.large_ruminants') },
  { id: FARMER_DOCUMENT_TYPE.SMALL_RUMINANTS, text: t('constants.farmer_document_type.small_ruminants') },
  { id: FARMER_DOCUMENT_TYPE.RISK_CENTER_REPORT, text: t('constants.farmer_document_type.risk_center_report') },
  { id: FARMER_DOCUMENT_TYPE.EXECUTION_PROCEEDINGS, text: t('constants.farmer_document_type.execution_proceedings') }
]
